import React, { SVGProps } from 'react';

const InformationIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8 1.90625C9.61616 1.90625 11.1661 2.54827 12.3089 3.69107C13.4517 4.83387 14.0938 6.38384 14.0938 8C14.0938 9.61616 13.4517 11.1661 12.3089 12.3089C11.1661 13.4517 9.61616 14.0938 8 14.0938C6.38384 14.0938 4.83387 13.4517 3.69107 12.3089C2.54827 11.1661 1.90625 9.61616 1.90625 8C1.90625 6.38384 2.54827 4.83387 3.69107 3.69107C4.83387 2.54827 6.38384 1.90625 8 1.90625ZM8 15.5C9.98912 15.5 11.8968 14.7098 13.3033 13.3033C14.7098 11.8968 15.5 9.98912 15.5 8C15.5 6.01088 14.7098 4.10322 13.3033 2.6967C11.8968 1.29018 9.98912 0.5 8 0.5C6.01088 0.5 4.10322 1.29018 2.6967 2.6967C1.29018 4.10322 0.5 6.01088 0.5 8C0.5 9.98912 1.29018 11.8968 2.6967 13.3033C4.10322 14.7098 6.01088 15.5 8 15.5ZM6.82812 10.3438C6.43848 10.3438 6.125 10.6572 6.125 11.0469C6.125 11.4365 6.43848 11.75 6.82812 11.75H9.17188C9.56152 11.75 9.875 11.4365 9.875 11.0469C9.875 10.6572 9.56152 10.3438 9.17188 10.3438H8.9375V7.76562C8.9375 7.37598 8.62402 7.0625 8.23438 7.0625H6.82812C6.43848 7.0625 6.125 7.37598 6.125 7.76562C6.125 8.15527 6.43848 8.46875 6.82812 8.46875H7.53125V10.3438H6.82812ZM8 6.125C8.24864 6.125 8.4871 6.02623 8.66291 5.85041C8.83873 5.6746 8.9375 5.43614 8.9375 5.1875C8.9375 4.93886 8.83873 4.7004 8.66291 4.52459C8.4871 4.34877 8.24864 4.25 8 4.25C7.75136 4.25 7.5129 4.34877 7.33709 4.52459C7.16127 4.7004 7.0625 4.93886 7.0625 5.1875C7.0625 5.43614 7.16127 5.6746 7.33709 5.85041C7.5129 6.02623 7.75136 6.125 8 6.125Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default InformationIcon;
